const ProjectsData = [
  {
    id: 1,
    name: "Todo List",
    img: "/Todo-List.jpeg",
    category: "Small Projects",
    url: "https://todolist-react12.netlify.app/",
    repo: "https://github.com/Captain-Price-1/Todo-List-React",
  },
  {
    id: 2,
    name: "Accordion",
    img: "/accordion.jpeg",
    category: "Small Projects",
    url: "https://react-accordion-own.netlify.app/",
    repo: "https://github.com/Captain-Price-1/accordion-react",
  },

  {
    id: 3,
    name: "Birthday-Reminder",
    img: "birthday-reminder.jpeg",
    category: "Small Projects",
    url: "https://birthday-reminder-react12.netlify.app/",
    repo: "https://github.com/Captain-Price-1/birthday-reminder-react",
  },
  {
    id: 4,
    name: "Tours Template",
    img: "/tours.jpeg",
    category: "Small Projects",
    url: "https://react-tours-template.netlify.app/",
    repo: "https://github.com/Captain-Price-1/react-tours-template-project",
  },
  {
    id: 5,
    name: "Food Menu",
    img: "FoodMenu.jpeg",
    category: "Small Projects",
    url: "https://menu-react12.netlify.app/",
    repo: "https://github.com/Captain-Price-1/menu-react",
  },
  {
    id: 6,
    name: "Tech News",
    img: "TechNews.jpeg",
    category: "Medium Projects",
    url: "https://react-tech-news.netlify.app/",
    repo: "https://github.com/Captain-Price-1/react-tech-news",
  },
  {
    id: 7,
    name: "Movies DataBase",
    img: "Movies.jpeg",
    category: "Medium Projects",
    url: "https://react-moovies.netlify.app/",
    repo: "https://github.com/Captain-Price-1/react-movies-animated",
  },
  {
    id: 8,
    name: "Stock Photos",
    img: "StockPhotos.jpeg",
    category: "Medium Projects",
    url: "https://react-photo-stock.netlify.app/",
    repo: "https://github.com/Captain-Price-1/react-stock-photos",
  },
  {
    id: 9,
    name: "Github User",
    img: "GithubUser.jpeg",
    category: "Large Projects",
    url: "https://react-own-github-user.netlify.app/",
    repo: "https://github.com/Captain-Price-1/react-own-github-user",
  },
];
export default ProjectsData;
